import { createAction } from 'redux-actions'

export const clearMembershipAndAor = createAction('CLEAR_MEMBERSHIP_AND_AOR')
